import { lsqTriggerSlice } from "components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice"
import React, { FunctionComponent, useEffect } from "react"
import { useDispatch } from "react-redux"
import { trackEventAsync } from "scripts/segment"
import { EXPERIMENT_SALES_LEAD } from "components/Profile/IeltsProfile/TestPrep/DataMapper"
import useDevice from "hooks/useDevice"
import ThankYouBanner from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/ThankYouBanner"
import Banner from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/Banner"
import HeaderLogo from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/HeaderLogo"
import styles from "public/static/scss/IeltsWebsite/PaymentBundle.module.scss"
import CallUsBanner from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/CallUsBanner"
import { Button } from "@leap/ui/Buttons"
import { ieltsPageName } from "utils/events-utils"
import { navRoutes } from "page_routes"

const LiyFlowThankyouPage: FunctionComponent = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(lsqTriggerSlice(EXPERIMENT_SALES_LEAD))
    trackEventAsync("Page Viewed", {
      pageName: "L2E Thank You Page with Call Now",
    })
  }, [])

  const handleGoToDashboard = async () => {
    await trackEventAsync("Click", {
      contentName: "Go to dashboard",
      pageName: ieltsPageName.THANQ_PAGE_MENA,
    })
    window.open(navRoutes.IELTS_STUDENT_DASHBOARD, "_self")
  }
  return (
    <div
      className={[
        "w-full bg-[#fbfcfe] pt-10 md:pt-14 md-min-w-[1000px] min-h-[800px] md:min-h-screen flex flex-col items-center md:block relative",
        styles["poppins-font-family"],
      ].join(" ")}
    >
      <HeaderLogo onClick={() => {}} />
      <div className="px-4 pt-8 md:max-w-[900px] mx-auto">
        <ThankYouBanner title="Great! You're a step closer to IELTS success." />
        <Banner
          heading="Our IELTS Expert will call you soon to book an evaluation."
          subHeading="During the evaluation with the teacher, discuss your test responses and tips on improving your IELTS score."
        />
        <div className="mt-6">
          <CallUsBanner />
        </div>
        <Button
          variant="primary"
          customCss="w-full max-w-[300px] px-4 py-[14px] md:max-w-[221px] rounded-xl flex items-center gap-2 justify-center  mt-6 mx-auto sticky bottom-0"
          onClick={handleGoToDashboard}
        >
          <p>Back To Dashboard</p>
        </Button>
      </div>
    </div>
  )
}

export default LiyFlowThankyouPage
